<template>
  <div class="row">
    <div class="col-lg-12">
      <!-- <button @click="testReminderFunction()">Test submission reminder function</button> -->
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <div class="card-title">
                <b-button variant="primary" class="btn btn-label btn-primary float-right"
                  v-b-modal.modal_addSafetyForm><i class="bx bx-plus label-icon"></i>Add Safety
                  Form</b-button>
                <b-modal id="modal_addSafetyForm" centered title="Add Safety Form" title-class="font-18" hide-footer
                  ref="modal_addSafetyForm" @hidden="clearForm">
                  <form-wizard color="#556ee6" @on-complete="createSafetyForm()" :start-index="0">
                    <tab-content icon="bx bx-detail" :before-change="() => validadeFormName()">
                      <div class="row">
                        <div class="col-12 text-center mt-4 mb-4">
                          <h2>What is the name of the safety form?</h2>
                          <h5 class="mb-4">
                            Your employees will see this name.
                          </h5>
                          <b-form-input v-model="add_SafetyForm.name" :class="{
                              'is-invalid': add_safetyForm_errors.nameError,
                            }"></b-form-input>
                          <div v-if="add_safetyForm_errors.nameError" class="invalid-feedback">
                            <span>{{
                              add_safetyForm_errors.nameErrorMessage
                              }}</span>
                          </div>
                        </div>
                        <!-- end col -->
                      </div>
                      <!-- end row -->
                    </tab-content>
                    <tab-content icon="bx bx-message" :before-change="() => validadeFormDescription()">
                      <div class="row">
                        <div class="col-12 text-center mt-4 mb-4">
                          <h2>Provide a description of what this form is.</h2>
                          <h5 class="mb-4">
                            Your employees will see this description.
                          </h5>
                          <b-form-textarea v-model="add_SafetyForm.description" rows="5" :class="{
                              'is-invalid': add_safetyForm_errors.descError,
                            }"></b-form-textarea>
                          <div v-if="add_safetyForm_errors.descError" class="invalid-feedback">
                            <span>{{
                              add_safetyForm_errors.descErrorMessage
                              }}</span>
                          </div>
                        </div>
                        <!-- end col -->
                      </div>
                    </tab-content>
                    <tab-content icon="bx bx-envelope" :before-change="() => validateNotificationEmail('add')">
                      <div class="row">
                        <div class="col-12 text-center mt-4">
                          <h2>
                            Would you like to be notified every time this form
                            is submitted?
                          </h2>
                          <h5 class="mb-4">
                            Add email addresses to which notifications will be
                            sent.
                          </h5>
                          <div v-for="(
                              email, index
                            ) in add_SafetyForm.notificationEmails" :key="index" class="d-flex">
                            <div v-if="index !== 0" class="d-flex mb-1 align-items-center removeEmailInput">
                              <i @click="
                                  handleRemoveNotificationEmailInput(
                                    'addForm',
                                    index
                                  )
                                " class="bx bx-x"></i>
                            </div>
                            <b-form-input v-model="add_SafetyForm.notificationEmails[index]" type="email"
                              placeholder="Enter an e-mail" :class="{
                                'is-invalid':
                                  add_safetyForm_errors.notificationEmailErrorMessage.find(
                                    (x) => x.index === index
                                  ),
                                'mb-1': true,
                                'ml-3':
                                  index === 0 &&
                                  add_SafetyForm.notificationEmails.length > 1,
                              }" pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"></b-form-input>
                            <!-- <div
                              v-if="
                                add_safetyForm_errors.notificationEmailError
                              "
                              class="invalid-feedback"
                            >
                              {{
                                add_safetyForm_errors.notificationEmailErrorMessage
                              }}
                            </div> -->
                          </div>
                        </div>
                        <div class="mb-4 mt-2 mx-auto d-flex addEmailInput">
                          <i @click="handleAddNotificationEmailInput('addForm')" class="bx bx-plus"></i>
                          <p @click="handleAddNotificationEmailInput('addForm')">
                            Add another e-mail
                          </p>
                        </div>
                      </div>
                    </tab-content>
                    <tab-content icon="mdi mdi-checkbox-marked-circle-outline">
                      <div class="row">
                        <div class="col-12 text-center mt-4 mb-5">
                          <h2>
                            <i class="mdi mdi-check-all"></i>
                          </h2>
                          <h2>
                            Setup complete. Click finish to add fields to your
                            safety form.
                          </h2>
                        </div>
                        <!-- end col -->
                      </div>
                      <!-- end row -->
                    </tab-content>
                  </form-wizard>
                </b-modal>
                <b-modal id="modal_editForm" title="Edit Form" title-class="font-18" ok-title="Submit"
                  @ok="submitEditForm" @cancel="handleEditFormCancel">
                  <div class="mb-4">
                    <div class="form-group">
                      <label>Name <i class="bx bxs-help-circle"></i></label>
                      <b-tooltip target="lbl_editField_name">The name of the form itself. This will inform the
                        mobile app user which form they are
                        selecting.</b-tooltip>
                      <b-form-input placeholder="Name..." v-model="edit_safetyForm.name" :class="{
                          'is-invalid': edit_safetyForm_errors.nameError,
                        }"></b-form-input>
                      <div v-if="edit_safetyForm_errors.nameError" class="invalid-feedback">
                        <span>{{ edit_safetyForm_errors.nameMessage }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="mb-4">
                    <div class="form-group">
                      <label id="lbl_editField_label">Description <i class="bx bxs-help-circle"></i></label>
                      <b-tooltip target="lbl_editField_label">The description is a small write-up explaining what the
                        form is and how/when it should be completed. Users will
                        see this on the mobile app.</b-tooltip>
                      <b-form-textarea v-model="edit_safetyForm.description" rows="5" :class="{
                          'is-invalid': edit_safetyForm_errors.descError,
                        }"></b-form-textarea>
                      <div v-if="edit_safetyForm_errors.descError" class="invalid-feedback">
                        <span>{{ edit_safetyForm_errors.descMessage }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="mb-4">
                    <div class="form-group">
                      <label id="lbl_editField_label">Notification E-mail</label>
                      <div v-for="(
                          email, index
                        ) in edit_safetyForm.notificationEmails" :key="index" class="d-flex">
                        <div class="d-flex mb-1 align-items-center removeEmailInput">
                          <i @click="
                              handleRemoveNotificationEmailInput(
                                'editForm',
                                index
                              )
                            " class="bx bx-x"></i>
                        </div>
                        <b-form-input v-model="edit_safetyForm.notificationEmails[index]" type="email"
                          placeholder="Enter an e-mail" :class="{
                            'is-invalid':
                              edit_safetyForm_errors.notificationEmailErrorMessage.find(
                                (x) => x.index === index
                              ),
                            'mb-1': true,
                          }" pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"></b-form-input>
                        <!-- <div
                          v-if="edit_safetyForm_errors.notificationEmailError"
                          class="invalid-feedback"
                        >
                          {{
                            edit_safetyForm_errors.notificationEmailErrorMessage
                          }}
                        </div> -->
                      </div>

                      <div class="mb-4 mt-2 mx-auto d-flex addEmailInput">
                        <i @click="handleAddNotificationEmailInput('editForm')" class="bx bx-plus"></i>
                        <p @click="handleAddNotificationEmailInput('editForm')">
                          Add another e-mail
                        </p>
                      </div>
                    </div>
                  </div>

                  <div v-if="jdcOrg">
                    <div class="mb-4">
                      <div class="form-group d-flex">
                        <label id="lbl_editField_workhubForm" class="mr-2">Workhub Form <i
                            class="bx bxs-help-circle"></i></label>
                        <b-tooltip target="lbl_editField_workhubForm">If you want this form to be emailed to Workhub check this box and provide the specific Workhub FormID. Everytime this form is submitted it will be sent to any provided Notification Emails as well as forms@workhub.com.</b-tooltip>
                        <b-form-checkbox v-model="edit_safetyForm.workhubForm"></b-form-checkbox>
                      </div>
                    </div>
  
                    <div v-if="edit_safetyForm.workhubForm" class="mb-5">
                      <div class="form-group d-flex">
                        <label id="lbl_editField_workhubFormID" class="mr-2">Workhub FormID <i
                          class="bx bxs-help-circle"></i>:</label>
                        <b-tooltip target="lbl_editField_workhubFormID">This allows the Workhub server to figure out what category of form it is as well as the customer that the form belongs to.</b-tooltip>
                        <div class="col-3">
                          <b-form-input type="text" maxlength="50"
                            v-model.trim="edit_safetyForm.workhubFormID" :class="{
                            'is-invalid': edit_safetyForm_errors.workhubFormIDError
                          }"></b-form-input>
                          <div v-if="edit_safetyForm_errors.workhubFormIDError" class="invalid-feedback">
                            <span>{{ edit_safetyForm_errors.workhubFormIDErrorMessage }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mb-4">
                    <div class="form-group d-flex" :class="{
                      'is-invalid': edit_safetyForm_errors.notificationEmailForSubmissionReminderError
                    }">
                      <label id="lbl_editField_submissionReminder" class="mr-2">Submission Reminder <i
                          class="bx bxs-help-circle"></i></label>
                      <b-tooltip target="lbl_editField_submissionReminder">This sets a time period after which, if the
                        safety form hasn't been submitted, an email notification will be sent to the provided
                        notification emails. The notification will explain that the form has not been submitted within
                        the specified time frame.</b-tooltip>
                      <b-form-checkbox v-model="edit_safetyForm.submissionReminder"></b-form-checkbox>
                    </div>
                    <div v-if="edit_safetyForm_errors.notificationEmailForSubmissionReminderError" class="invalid-feedback">
                      <span>{{ edit_safetyForm_errors.notificationEmailForSubmissionReminderErrorMessage }}</span>
                    </div>
                  </div>

                  <div v-if="edit_safetyForm.submissionReminder" class="mb-4">
                    <div class="form-group d-flex">
                      <label>Duration:</label>
                      <div class="col-3">
                        <b-form-input type="number" step="1" min="0"
                          v-model="edit_safetyForm.submissionReminderTime.duration" :class="{
                          'is-invalid': edit_safetyForm_errors.submissionReminderDurationError
                        }"></b-form-input>
                        <div v-if="edit_safetyForm_errors.submissionReminderDurationError" class="invalid-feedback">
                          <span>{{ edit_safetyForm_errors.submissionReminderDurationErrorMessage }}</span>
                        </div>
                      </div>
                      <label>Time Unit:</label>
                      <div class="col-5">
                        <v-select :class="{
                          'is-invalid': edit_safetyForm_errors.submissionReminderTimeUnitError
                        }" :options="['Days', 'Weeks', 'Months', 'Years']" :clearable="false"
                          v-model="edit_safetyForm.submissionReminderTime.timeUnit"></v-select>
                        <div v-if="edit_safetyForm_errors.submissionReminderTimeUnitError" class="invalid-feedback">
                          <span>{{ edit_safetyForm_errors.submissionReminderTimeUnitErrorMessage }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                </b-modal>
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-8">
              <div class="row mt-4">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show&nbsp;
                      <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                    </label>
                  </div>
                </div>
                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input v-model="filter" type="search" placeholder="Search..."
                        class="form-control form-control-sm ml-2"></b-form-input>
                    </label>
                  </div>
                </div>
                <!-- End search -->
              </div>
              <div class="table-responsive mb-0">
                <b-table id="sortableTable" v-sortable="sortableOptions" :items="tableData" :fields="fields"
                  responsive="sm" :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc" :filter="filter" :filter-included-fields="filterOn">
                  <template v-slot:cell(edit)="data">
                    <b-dropdown variant="primary" size="sm">
                      <template v-slot:button-content>
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item @click="editFormFields(data.item.edit, data.item.name)"><i
                          class="bx bx-list-ol mr-2 tableIcons"></i>Edit Form
                        Fields</b-dropdown-item>
                      <b-dropdown-divider></b-dropdown-divider>
                      <b-dropdown-item v-b-modal.modal_editForm @click="editForm(data)"><i
                          class="bx bx-pencil mr-2 tableIcons"></i>Edit</b-dropdown-item>
                      <b-dropdown-item @click="cloneForm(data.item.edit)"><i
                          class="bx bx-copy-alt mr-2 tableIcons"></i>Clone
                        Form</b-dropdown-item>
                      <b-dropdown-item @click="deleteForm(data.item.edit)"><i
                          class="bx bx-trash mr-2 tableIcons"></i>Delete</b-dropdown-item>
                    </b-dropdown>
                  </template>
                  <template v-slot:cell(email)="data">
                    <tr v-for="(email, index) in data.item.email" :key="index">
                      <td v-if="index !== data.item.email.length - 1" class="border-0 p-0 pb-1">
                        {{ email }}
                      </td>
                      <td v-else class="border-0 p-0">{{ email }}</td>
                    </tr>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination v-model="currentPage" :total-rows="tableData.length"
                        :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- /Kiefer -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import { getSafetyForms } from '../../helper/dbHelpers.js';
import { FormWizard, TabContent } from 'vue-form-wizard';
import Swal from 'sweetalert2';
// import axios from 'axios';

import { tableSort } from '../../helper/helpers.js';

import Sortable from 'sortablejs';
// import Buefy from 'buefy';
// import Vue from 'vue';
const createSortable = (el, options) => {
  return Sortable.create(el, {
    ...options,
  });
};

const sortable = {
  name: 'sortable',
  bind(el, binding, vnode) {
    const table = el;
    table._sortable = createSortable(
      table.querySelector('tbody'),
      binding.value,
      vnode
    );
  },
};

export default {
  components: {
    FormWizard,
    TabContent,
  },
  directives: { sortable },
  data() {
    return {
      sortableOptions: {
        chosenClass: 'is-selected',
      },
      name: 'searchJobsComponent',
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'job',
      sortDesc: true,
      fields: [
        { key: 'edit', sortable: false },
        { key: 'name', sortable: true },
        { key: 'desc', sortable: true },
        { key: 'email', sortable: true },
        { key: 'assigned', sortable: true },
      ],
      tableData: [],
      add_SafetyForm: {
        name: null,
        description: null,
        notificationEmails: [''],
      },
      add_safetyForm_errors: {
        nameError: false,
        nameErrorMessage: null,
        descError: false,
        descErrorMessage: null,
        notificationEmailError: false,
        notificationEmailErrorMessage: [],
      },
      edit_safetyForm: {
        id: null,
        index: null,
        name: null,
        description: null,
        notificationEmails: [''],
        submissionReminder: false,
        submissionReminderTime: {duration: null, timeUnit: 'Days'},
        workhubForm: false,
        workhubFormID: null,
      },
      edit_safetyForm_errors: {
        nameError: false,
        nameErrorMessage: null,
        descError: false,
        descErrorMessage: null,
        notificationEmailError: false,
        notificationEmailErrorMessage: [],
        submissionReminderDurationError: false,
        submissionReminderDurationErrorMessage: null,
        submissionReminderTimeUnitError: false,
        submissionReminderTimeUnitErrorMessage: null,
        notificationEmailForSubmissionReminderError: false,
        notificationEmailForSubmissionReminderErrorMessage: null,
        workhubFormIDError: false,
        workhubFormIDErrorMessage: null,
      },
      currentUser: [],
      jdcOrg: false,
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },
  },
  watch: {
    perPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        let currentUserDataCopy = JSON.parse(JSON.stringify(this.currentUser));
        let oldCurrentUserPerPage = null;

        if (currentUserDataCopy.tablePageLengths) {
          if(currentUserDataCopy.tablePageLengths.perPage_safetyForms){
            oldCurrentUserPerPage = currentUserDataCopy.tablePageLengths.perPage_safetyForms;
          }
          currentUserDataCopy.tablePageLengths['perPage_safetyForms'] = newVal;
        } else {
          currentUserDataCopy['tablePageLengths'] = {
            perPage_safetyForms: newVal,
          };
        }

        if (oldCurrentUserPerPage !== newVal) {
          try {
            firebase
              .firestore()
              .collection('employees')
              .doc(this.currentUser.auth)
              .update({
                tablePageLengths: currentUserDataCopy.tablePageLengths,
              });
          } catch (err) {
            console.log('Error updating user table settings in db: ', err);
          }
        }
        this.currentUser = currentUserDataCopy;
        this.$store.dispatch('custom/updateUserData', currentUserDataCopy);
      }
    },
    currentUser(newVal, oldVal){
      if (newVal !== oldVal) {
        if(newVal.org && newVal.org === '8yPABSmtFKQ8mtXDe51w'){
          this.jdcOrg = true;
        }
      }
    },
  },
  methods: {
    // testReminderFunction: function () {
    //   console.log('run')
    //   let request = {
    //     uid: `done`,
    //   };
    //   axios
    //     .get(
    //       'http://localhost:5000/kali-45420/us-central1/dailyTask',
    //       {
    //         params: {
    //           request,
    //         },
    //       }
    //     )
    //     .then((response) => {
    //       if (response.status == 200) {
    //         console.log("Daily task success")
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(`Error calling the daily task function: ${err}`);
    //       console.log(err);
    //     });
    // },
    populateSafetyForms: function () {
      getSafetyForms()
        .then((response) => {
          if (response.empty) {
            console.log('no data');
          } else {
            let tempArg = [];
            response.forEach((doc) => {
              // notifcation emails can be undefined, null, a string or an array so we have to format it for the table
              const email = doc.data().notificationEmail;
              let tableFormattedEmail = [];
              if (email && email !== null) {
                if (typeof email !== 'string' && email.length !== undefined) {
                  tableFormattedEmail = email;
                } else {
                  tableFormattedEmail.push(email);
                }
              }

              if(!doc.data().dateDeactivated){
                  tempArg.push({
                  edit: doc.id,
                  name: doc.data().displayName,
                  desc: doc.data().description,
                  email: tableFormattedEmail,
                  assigned: doc.data().assigned,
                  submissionReminder: doc.data().submissionReminder ? doc.data().submissionReminder : {duration: null, timeUnit: 'Days'},
                  workhubForm: (this.jdcOrg && doc.data().workhubForm) ? doc.data().workhubForm : false,
                  workhubFormID: (this.jdcOrg && doc.data().workhubFormID) ? doc.data().workhubFormID : null
                });
              }
            });
            this.tableData = tempArg;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    createSafetyForm: function () {
      try {
        // run email input validation
        if (this.validateNotificationEmail('add')) {
          //create the form and redirect the user to the form detail page, so they can add the fields.
          firebase
            .firestore()
            .collection('organizations')
            .doc(sessionStorage.getItem('org'))
            .collection('safetyForms')
            .add({
              docName: this.add_SafetyForm.name
                .toLowerCase()
                .replace(/\s/g, ''),
              displayName: this.add_SafetyForm.name,
              description: this.add_SafetyForm.description,
              notificationEmail: this.add_SafetyForm.notificationEmails,
            })
            .then((doc) => {
              this.tableData.push({
                edit: doc.id,
                name: this.add_SafetyForm.name,
                desc: this.add_SafetyForm.description,
                email: this.add_SafetyForm.notificationEmails,
              });
              this.$router.push({
                name: 'editSafetyForm',
                params: {
                  id: doc.id,
                  name: this.add_SafetyForm.name,
                  forms: this.tableData,
                },
              });
            })
            .catch((err) => {
              Swal.fire('Error!', `Error creating safety for: ${err}`, 'error');
            });
        }
      } catch (err) {
        Swal.fire('Error!', `Error creating safety for: ${err}`, 'error');
      }
    },
    validadeFormName: function () {
      //check to make sure the name field is filled out
      if (
        this.add_SafetyForm.name == null ||
        this.add_SafetyForm.name.trim() == ''
      ) {
        this.add_safetyForm_errors.nameError = true;
        this.add_safetyForm_errors.nameErrorMessage = 'A name must be provided';
        return false;
      } else {
        this.add_safetyForm_errors.nameError = false;
        this.add_safetyForm_errors.nameErrorMessage = null;
        return true;
      }
    },
    validadeFormDescription: function () {
      //check to make sure the description field is filled out
      if (
        this.add_SafetyForm.description == null ||
        this.add_SafetyForm.description.trim() == ''
      ) {
        this.add_safetyForm_errors.descError = true;
        this.add_safetyForm_errors.descErrorMessage =
          'A description must be provided';
        return false;
      } else {
        this.add_safetyForm_errors.descError = false;
        this.add_safetyForm_errors.descErrorMessage = null;
        return true;
      }
    },
    validateNotificationEmail: function(formType) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      let form, formErrors;
      let noErrors = true;

      if (formType === 'add') {
        form = JSON.parse(JSON.stringify(this.add_SafetyForm));
        formErrors = this.add_safetyForm_errors;
      } else if (formType === 'edit') {
        form = this.edit_safetyForm;
        formErrors = this.edit_safetyForm_errors;
      } else {
        throw new Error('Invalid form type specified');
      }

      // clear errors as indexes may have changed if any email inputs were removed
      formErrors.notificationEmailErrorMessage = [];
      // loop through all email inputs and check for errors
      form.notificationEmails.forEach((email, index) => {
        // If email is not null or empty, then validate it
        if (email && email.trim() !== "" && (!email || (email && !emailPattern.test(email.trim())))) {
          formErrors.notificationEmailError = true;
          formErrors.notificationEmailErrorMessage.push({
            message: 'Invalid email address format',
            index: index,
          });
          noErrors = false;
        } else {
          // If there is no error, clear the previous error message
          const inputErrorIndex =
            formErrors.notificationEmailErrorMessage.findIndex(
              (x) => x.index == index
            );
          formErrors.notificationEmailError = false;
          if (inputErrorIndex !== -1) {
            formErrors.notificationEmailErrorMessage.splice(inputErrorIndex, 1);
          }
        }
      });

      return noErrors; // Return true if there is no error
    },

    handleAddNotificationEmailInput: function (formType) {
      if (formType === 'addForm') {
        // make copy of array of notification emails and add new input to it
        let notiEmailsCopy = JSON.parse(
          JSON.stringify(this.add_SafetyForm.notificationEmails)
        );

        notiEmailsCopy.push('');

        this.add_SafetyForm.notificationEmails = notiEmailsCopy;
      } else if (formType === 'editForm') {
        // make copy of array of notification emails and add new input to it
        let notiEmailsCopy = JSON.parse(
          JSON.stringify(this.edit_safetyForm.notificationEmails)
        );

        notiEmailsCopy.push('');

        this.edit_safetyForm.notificationEmails = notiEmailsCopy;
      }
    },

    handleRemoveNotificationEmailInput: function (formType, index) {
      if (formType === 'addForm') {
        // make copy of array of notification emails and remove input from it
        let notiEmailsCopy = JSON.parse(
          JSON.stringify(this.add_SafetyForm.notificationEmails)
        );

        notiEmailsCopy.splice(index, 1);

        this.add_SafetyForm.notificationEmails = notiEmailsCopy;
      } else if (formType === 'editForm') {
        // make copy of array of notification emails and remove input from it
        let notiEmailsCopy = JSON.parse(
          JSON.stringify(this.edit_safetyForm.notificationEmails)
        );

        notiEmailsCopy.splice(index, 1);

        this.edit_safetyForm.notificationEmails = notiEmailsCopy;
      }
    },

    deleteForm: function (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'This item will be deleted permanently',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          //remove the item from the array and then udpate the db with the new array.
          this.tableData = this.tableData.filter(function (obj) {
            return obj.edit !== id;
          });
          firebase
            .firestore()
            .collection('organizations')
            .doc(sessionStorage.getItem('org'))
            .collection('safetyForms')
            .doc(id)
            .update({
              dateDeactivated: new Date(),
            })
            .then(() => {
              Swal.fire('Success!', 'Form successfully deleted.', 'success');
              this.formItemsTotalRows += -1;
            })
            .catch(() => {
              Swal.fire(
                'Error!',
                'An error was encounted when deleteing the record.',
                'error'
              );
            });
        }
      });
    },
    editForm: function (tableRowData) {
      let data = JSON.parse(JSON.stringify(tableRowData));
      this.edit_safetyForm.id = data.item.edit;
      this.edit_safetyForm.index = data.index;
      this.edit_safetyForm.name = data.item.name;
      this.edit_safetyForm.description = data.item.desc;
      this.edit_safetyForm.notificationEmails = data.item.email;
      // set the submission reminder checkbox
      this.edit_safetyForm.submissionReminder = data.item.submissionReminder.duration !== null && data.item.submissionReminder.timeUnit !== null;
      this.edit_safetyForm.submissionReminderTime = data.item.submissionReminder;
      // set the workhub form values
      this.edit_safetyForm.workhubForm = (this.jdcOrg && data.item.workhubForm) ? data.item.workhubForm : false;
      this.edit_safetyForm.workhubFormID = (this.jdcOrg && data.item.workhubFormID) ? data.item.workhubFormID : null;
    },
    validateEditField: function () {
      let flag = true;

      //check to make sure the name isn't empty
      if (
        this.edit_safetyForm.name == null ||
        this.edit_safetyForm.name.trim() == ''
      ) {
        this.edit_safetyForm_errors.nameError = true;
        this.edit_safetyForm_errors.nameMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.edit_safetyForm_errors.nameError = false;
        this.edit_safetyForm_errors.nameMessage = null;
      }
      //check to make sure the label value isn't empty
      if (
        this.edit_safetyForm.description == null ||
        this.edit_safetyForm.description.trim() == ''
      ) {
        this.edit_safetyForm_errors.descError = true;
        this.edit_safetyForm_errors.descMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.edit_safetyForm_errors.descError = false;
        this.edit_safetyForm_errors.descMessage = null;
      }

      if (!this.validateNotificationEmail('edit')) {
        flag = false;
      } else {
        this.edit_safetyForm_errors.notificationEmailError = false;
        this.edit_safetyForm_errors.notificationEmailErrorMessage = [];
      }

      // check to make sure that if submission reminder is selected, then duration and time unit isn't empty
      if (this.edit_safetyForm.submissionReminder) {
        if (!this.edit_safetyForm.submissionReminderTime.duration) {
          this.edit_safetyForm_errors.submissionReminderDurationError = true;
          this.edit_safetyForm_errors.submissionReminderDurationErrorMessage = 'Value cannot be empty.';
          flag = false;
        } else {
          this.edit_safetyForm_errors.submissionReminderDurationError = false;
          this.edit_safetyForm_errors.submissionReminderDurationErrorMessage = null;
        }

        if (!this.edit_safetyForm.submissionReminderTime.timeUnit) {
          this.edit_safetyForm_errors.submissionReminderTimeUnitError = true;
          this.edit_safetyForm_errors.submissionReminderTimeUnitErrorMessage = 'Value cannot be empty.';
          flag = false;
        } else {
          this.edit_safetyForm_errors.submissionReminderTimeUnitError = false;
          this.edit_safetyForm_errors.submissionReminderTimeUnitErrorMessage = null;
        }

        if (this.edit_safetyForm.notificationEmails.length === 0 || !this.edit_safetyForm.notificationEmails.find((x) => x.trim() !== "")) {
          this.edit_safetyForm_errors.notificationEmailForSubmissionReminderError = true;
          this.edit_safetyForm_errors.notificationEmailForSubmissionReminderErrorMessage = 'At least one notification email must be provided in order for the submission reminder to be enabled.';
          flag = false;
        } else {
          this.edit_safetyForm_errors.notificationEmailForSubmissionReminderError = false;
          this.edit_safetyForm_errors.notificationEmailForSubmissionReminderErrorMessage = null;
        }
      }
      else {
        this.edit_safetyForm_errors.submissionReminderDurationError = false;
        this.edit_safetyForm_errors.submissionReminderDurationErrorMessage = null;
        this.edit_safetyForm_errors.submissionReminderTimeUnitError = false;
        this.edit_safetyForm_errors.submissionReminderTimeUnitErrorMessage = null;
        this.edit_safetyForm_errors.notificationEmailForSubmissionReminderError = false;
        this.edit_safetyForm_errors.notificationEmailForSubmissionReminderErrorMessage = null;
      }

      // check to make sure that if Workhub Form is selected, then the Workhub FormID isn't empty
      if (this.edit_safetyForm.workhubForm) {
        if (!this.edit_safetyForm.workhubFormID || this.edit_safetyForm.workhubFormID.trim() === '') {
          this.edit_safetyForm_errors.workhubFormIDError = true;
          this.edit_safetyForm_errors.workhubFormIDErrorMessage = 'Value cannot be empty.';
          flag = false;
        } else {
          this.edit_safetyForm_errors.workhubFormIDError = false;
          this.edit_safetyForm_errors.workhubFormIDErrorMessage = null;
        }
      }
      else {
        this.edit_safetyForm_errors.workhubFormIDError = false;
        this.edit_safetyForm_errors.workhubFormIDErrorMessage = null;
      }

      return flag;
    },
    submitEditForm: function (bvModalEvt) {
      //check to see if the edit modal contains valid entries.
      if (this.validateEditField() === true) {
        //update the form info.
        firebase
          .firestore()
          .collection('organizations')
          .doc(sessionStorage.getItem('org'))
          .collection('safetyForms')
          .doc(this.edit_safetyForm.id)
          .update({
            docName: this.edit_safetyForm.name.toLowerCase().replace(/\s/g, ''),
            displayName: this.edit_safetyForm.name,
            description: this.edit_safetyForm.description,
            notificationEmail: this.edit_safetyForm.notificationEmails,
            submissionReminder: this.edit_safetyForm.submissionReminder ?
              this.edit_safetyForm.submissionReminderTime :
              null,
            workhubForm: this.edit_safetyForm.workhubForm ?
              this.edit_safetyForm.workhubForm :
              false,
            workhubFormID: this.edit_safetyForm.workhubFormID ?
              this.edit_safetyForm.workhubFormID :
              null, 
          })
          .then(() => {
            this.tableData[this.edit_safetyForm.index] = {
              edit: this.edit_safetyForm.id,
              name: this.edit_safetyForm.name,
              desc: this.edit_safetyForm.description,
              email: this.edit_safetyForm.notificationEmails,
              submissionReminder: this.edit_safetyForm.submissionReminder ?
                this.edit_safetyForm.submissionReminderTime :
                null,
              workhubForm: this.edit_safetyForm.workhubForm ?
                this.edit_safetyForm.workhubForm :
                false,
              workhubFormID: this.edit_safetyForm.workhubFormID ?
                this.edit_safetyForm.workhubFormID :
                null, 
            };
            Swal.fire('Success!', 'Form successfully updated.', 'success');
            this.populateSafetyForms();
          })
          .catch((err) => {
            Swal.fire('Error!', `Error creating safety for: ${err}`, 'error');
          });
      } else {
        bvModalEvt.preventDefault();
      }
    },
    handleEditFormCancel: function () {
      this.edit_safetyForm_errors.notificationEmailError = false;
      this.edit_safetyForm_errors.notificationEmailErrorMessage = [];
    },
    editFormFields: function (id, name) {
      //send the user to the edit form page.
      this.$router.push({
        name: 'editSafetyForm',
        params: {
          id: id,
          name: name,
          forms: this.tableData,
        },
      });
    },
    cloneForm: function (formDocID) {
      //create a copy of the item in the array at the selected index and add it to the end of the array.
      let index = this.tableData.findIndex((x) => x.edit === formDocID);
      this.add_SafetyForm.name = this.tableData[index].name + ' - copy';
      this.add_SafetyForm.description = this.tableData[index].desc;
      this.add_SafetyForm.notificationEmails = this.tableData[index].email;

      //get the fields from the form that is being cloned.
      try {
        firebase
          .firestore()
          .collection('organizations')
          .doc(sessionStorage.getItem('org'))
          .collection('safetyForms')
          .doc(this.tableData[index].edit)
          .get()
          .then((doc) => {
            //get the inputs from the selected form.
            let inputs = doc.data().inputs;

            //create the form and redirect the user to the form detail page, so they can add the fields.
            if(inputs === undefined){
              inputs = [];
            }

            firebase
              .firestore()
              .collection('organizations')
              .doc(sessionStorage.getItem('org'))
              .collection('safetyForms')
              .add({
                docName: this.add_SafetyForm.name
                  .toLowerCase()
                  .replace(/\s/g, ''),
                displayName: this.add_SafetyForm.name,
                description: this.add_SafetyForm.description,
                notificationEmail: this.add_SafetyForm.notificationEmails,
                inputs: inputs,
              })
              .then((doc) => {
                this.tableData.push({
                  edit: doc.id,
                  name: this.add_SafetyForm.name,
                  desc: this.add_SafetyForm.description,
                  email: this.add_SafetyForm.notificationEmails,
                });
                this.$router.push({
                  name: 'editSafetyForm',
                  params: {
                    id: doc.id,
                    name: this.add_SafetyForm.name,
                    forms: this.tableData,
                  },
                });
              })
              .catch((err) => {
                Swal.fire(
                  'Error!',
                  `Error creating safety form: ${err}`,
                  'error'
                );
              });
          })
          .catch((err) => {
            Swal.fire(
              'Error!',
              `Error retrieving existing form: ${err}`,
              'error'
            );
          });
      } catch (err) {
        Swal.fire('Error!', `Error cloning safety form: ${err}`, 'error');
      }

      //after the new form is created, we also need to copy all of the fields.
    },
    setTableSettings: function () {
      this.currentUser = this.$store.state.custom.currentUserData;
      if (this.currentUser.tablePageLengths) {
        if (this.currentUser.tablePageLengths.perPage_safetyForms) {
          this.perPage = this.currentUser.tablePageLengths.perPage_safetyForms;
        }
      }
    },
    tableSort: tableSort,
    clearForm: function () {
      this.add_SafetyForm.name = null;
      this.add_SafetyForm.description = null;
      this.add_SafetyForm.notificationEmails = [''];
      this.add_safetyForm_errors.nameError = false;
      this.add_safetyForm_errors.nameErrorMessage = null;
      this.add_safetyForm_errors.descError = false;
      this.add_safetyForm_errors.descErrorMessage = null;
      this.add_safetyForm_errors.notificationEmailError = false;
      this.add_safetyForm_errors.notificationEmailErrorMessage = [];
    },
  },
  created: function () {
    this.populateSafetyForms();
    this.setTableSettings();
  },
};

// Sortable.create(document.getElementById('sortableTable'), {});
</script>

<style scoped lang="scss">
.addEmailInput {
  color: #556ee6;
  i {
    font-size: 1rem;
    padding-top: 0.08rem;
  }
  i:hover,
  p:hover {
    cursor: pointer;
  }
}

.removeEmailInput {
  color: #556ee6;
  i {
    font-size: 1rem;
    padding-top: 0.08rem;
  }
  i:hover,
  p:hover {
    cursor: pointer;
  }
}
</style>
